import React from "react";

const Person = ({ person }) => {
  return person.map((value, index) => {
    return (
      <>
        <div
          key={`person${index * 2}`}
          className="item details d-lg-flex d-none"
        >
          <div className="itemValue col-6">
            {value.fname} {value.lname}
          </div>
          <div className="itemValue col-6">{value.mobile}</div>
        </div>
        <div
          className="headers_table d-flex d-lg-none flex-wrap"
          key={`person${index * 2 + 1}`}
        >
          <div className="item col-12 col-md-12">
            نام و نام خانوادگی :{" "}
            <span className="itemValue">
              {value.fname} {value.lname}
            </span>
          </div>
          <div className="item col-12 col-md-12">
            شماره تماس : <span className="itemValue">{value.mobile}</span>
          </div>
        </div>
      </>
    );
  });
};

export default Person;
